import { listClients } from '../../api/clients'
import { listPatients } from '../../api/patients'
import { listRecentConsultations } from '../../api/clinical'
import { Card } from '../ui/Card'
import { useFetch } from '../../hooks/useFetch'
import { cn } from '@/lib/utils'

export function StatsWidget() {
  const { data: stats } = useFetch(
    () => Promise.all([listClients({ limit: 1 }), listPatients({ limit: 1 })])
      .then(([clients, patients]) => ({ totalClients: clients.total, totalPatients: patients.total })),
    [],
  )

  // Capped at the API's max page (50); shown as "50+" beyond that.
  const { data: openConsultations, loading: consultLoading } = useFetch(
    () => listRecentConsultations(50, 'open'),
    [],
  )
  const openCount = openConsultations?.length ?? 0

  return (
    <div className="grid grid-cols-[repeat(auto-fill,minmax(170px,1fr))] gap-4">
      <Card>
        <div className="text-[0.72rem] font-semibold text-text-3 uppercase tracking-[0.05em] mb-[0.4rem]">Clients</div>
        <div className={cn('text-[2rem] font-bold leading-none', stats ? 'text-text-heading' : 'text-border-input')}>
          {stats?.totalClients ?? '—'}
        </div>
      </Card>
      <Card>
        <div className="text-[0.72rem] font-semibold text-text-3 uppercase tracking-[0.05em] mb-[0.4rem]">Patients</div>
        <div className={cn('text-[2rem] font-bold leading-none', stats ? 'text-text-heading' : 'text-border-input')}>
          {stats?.totalPatients ?? '—'}
        </div>
      </Card>
      <Card>
        <div className="text-[0.72rem] font-semibold text-text-3 uppercase tracking-[0.05em] mb-[0.4rem]">Open Records</div>
        <div className="text-[2rem] font-bold leading-none text-accent">
          {consultLoading ? '—' : openCount >= 50 ? '50+' : openCount}
        </div>
      </Card>
    </div>
  )
}
